<template>
    <div class="row justify-content-between">
        <div class="col-7-md" style="width: 500px;">
            <h2>Additional Profiles</h2>
            <br>
            <p>Select the number of additional profiles</p>
            <div class="row">
            <b-form-group class="col-6">
                <b-form-select
                    id="additionalProfiles"
                    v-model="selectedProfiles"
                    class="form-control"
                    :options="profileList"
                ></b-form-select>
            </b-form-group>
            
            <div class="col-6" style="width:400px;">
                <b-button
                        type="button"
                        variant="primary"
                        class="ml-2"
                        @click="calculateSubscription()"
                        >Apply</b-button>
                    <b-button
                        type="button"
                        variant="outline-primary"
                        class="ml-2 with-border"
                        @click="appliedData=null"
                        >Reset</b-button>

            </div>

            </div>
        </div>
        <div v-if="appliedData" class="col-5-md" style="width:370px;">
            <div style="width:100%;border-bottom: 1px solid #CBC5C9;" class="p-2">
                <span style="font-size: 24px;">{{ appliedData.profiles }}</span> <br />
                <span style="font-size: 14px;" class="text-muted">Total profiles to be purchased</span>
            </div>
            <!-- <div style="width:100%;" class="p-2">
                <span style="font-size: 14px;" class="text-muted">Total</span>
                <span style="font-size: 28px; color: var(--primary-color)"> {{appliedData.currency}} {{ appliedData.totalAmount }}</span>
            </div> -->
            <div>
                <b-table :fields="invoiceFields" :items="appliedData.items">
                </b-table>

                <template v-if="taxPercentage">
                    <div class="row mt-3">
                        <div class="col-4"></div>
                        <div class="col-4 text-muted" style="font-size: 16px; ">Sub Total</div>
                        <div class="col-4 font-weight-bold" style="font-size: 16px;">{{ appliedData.currency }} {{ appliedData.subTotalAmount }}</div>
                    </div>
                    <div v-for="tax in appliedData.taxDetails" class="row mt-3">
                        <div class="col-4"></div>
                        <div class="col-4 text-muted" style="font-size: 16px; ">{{ tax.title }} ({{ tax.percentage }}%)</div>
                        <div class="col-4 font-weight-bold" style="font-size: 16px;">{{ appliedData.currency }} {{ tax.amount }}</div>
                    </div>
                </template>
                <div class="row mt-3">
                    <div class="col-4"></div>
                    <div class="col-4 text-muted" style="font-size: 16px; ">Total Amount</div>
                    <div class="col-4 font-weight-bold" style="font-size: 16px;">{{ appliedData.currency }} {{ appliedData.totalAmount }}</div>
                </div>
                <div class="text-right mt-2">
                    <b-button
                        type="button"
                        variant="warning"
                        style="color:white;"
                        @click.prevent="onSubmit(appliedData.totalAmount, appliedData.profiles)"
                        :disabled="isLoading"
                        >Subscribe Now</b-button>
                </div>
            </div>
        </div>


    </div>
</template>
<script>
import _ from 'lodash'
import request from '@/utils/request';

    export default {
        props: {
            tier: {
                type: Number,
                default: 0,
            },
            packages: {
                type: Array,
                default: [],
            },
            user: {
                type: Object,
                default: {},
            },
            taxPercentage: {
                type: Number,
                default: null,
            },

        },
        data(){
            return {
                selectedProfiles: 50,
                isLoading: false,
                profileList: [],
                appliedData: null,
                invoiceFields: {
                    profiles: {
                        label: 'Profiles',
                        // sortable: true,
                        tdAttr: {
                            dataname: 'profiles',
                        },
                    },
                    costPerProfile: {
                        label: 'Cost per Profile',
                        // sortable: true,
                        tdAttr: {
                            dataname: 'costPerProfile',
                        },
                    },
                    total: {
                        label: 'Total',
                        // sortable: true,
                        tdAttr: {
                            dataname: 'total',
                        },
                    },
                },
            }
        },
        created(){
            const tempList = []
            for(let i=50; i<=2000; i+=50) {
                tempList.push(i);
            }
            this.profileList = [...tempList];
        },
        methods: {
            calculateSubscription(){
                const currency = this.packages.find(el => !!el.currency).currency;
                const tier = parseInt(this.tier);
                const profiles = this.selectedProfiles + tier;
                const tempAppliedData = {
                    profiles: Math.abs(tier - profiles),
                    taxDetails: [],
                    subTotalAmount: 0,
                    totalAmount: 0,
                    currency: currency || 'USD',
                    items: [],
                };
                // const sortedPackages = this.packages.sort((first, second) => first.onboardings.min - second.onboardings.min).filter(el=> el.onboardings.max > tier);
                const sortedPackages = this.packages.filter(el=> (el.onboardings.max > tier && el.onboardings.max != el.onboardings.min ) ).sort((first, second) => first.onboardings.min - second.onboardings.min);
                console.log("profiles", profiles)
                console.log("sortedPackages", sortedPackages)
                let processedProfiles = 0;
                let firstIteration = true;
                for(let pkg of sortedPackages) {
                    let addDiff = processedProfiles > 0 ? Number(pkg.onboardings.min)  - Number(processedProfiles) : 0 
                    console.log("iteration addDiff", addDiff)
                    const profileCount = profiles<=pkg.onboardings.max ? 
                                            Math.abs(processedProfiles - profiles) : 
                                                processedProfiles==0 ? pkg.onboardings.max : (pkg.onboardings.max - pkg.onboardings.min) + addDiff;
                    console.log("iteration processedProfiles", processedProfiles)
                    console.log("iteration profileCount", profileCount)
                    if(profileCount==0) {
                        break;
                    }
                    processedProfiles+= profileCount;
                    let tempTotal = firstIteration ? _.round( (Math.abs(tier - profileCount)) * pkg.price , 2) : _.round(profileCount * pkg.price , 2);
                    tempAppliedData.items.push({
                        packageId: pkg._id,
                        profiles: firstIteration ? Math.abs(tier - profileCount) : profileCount,
                        costPerProfile: pkg.price,
                        total: tempTotal,
                    })
                    tempAppliedData.subTotalAmount += tempTotal;
                    if(profiles<=pkg.max) {
                        break;
                    }
                    firstIteration = false;
                }
                const TAX_AMOUNT = this.taxPercentage ?  parseFloat(tempAppliedData.subTotalAmount * (this.taxPercentage/100)).toFixed(2) : 0;
                tempAppliedData.taxAmount = TAX_AMOUNT;
                if(this.taxPercentage) {
                    tempAppliedData.taxDetails = [
                        {
                            title: 'VAT',
                            percentage: this.taxPercentage,
                            amount: TAX_AMOUNT,
                        },
                    ];
                }
                tempAppliedData.totalAmount = parseFloat( parseFloat(tempAppliedData.subTotalAmount) + parseFloat(TAX_AMOUNT)).toFixed(2);
                tempAppliedData.subTotalAmount = parseFloat(tempAppliedData.subTotalAmount).toFixed(2);
                this.appliedData = tempAppliedData;
            },
            async onSubmit(amount, quantity) {
            try {
                this.isLoading = true;
                const pkg = this.packages.find(el=> el.onboardings.min <= quantity && el.onboardings.max >= quantity)
                console.log('pkg', pkg)
                this.$analytics.fbq.event(
                    'subscribe ' + quantity + ' additionalProfilesClicked'
                )
                let {data} = await request.post('users/create-invoice', {
                    invoiceData: this.appliedData,
                    timezoneOffset: (new Date()).getTimezoneOffset(),
                    type: 'additional-profiles'
                })

                // let data = await this.$store.dispatch('createCheckoutSession', {
                //     user: this.user,
                //     quantity,
                //     amount: parseFloat(amount).toFixed(2),
                //     productId: pkg.stripeProductId,
                //     currency: pkg.currency,
                // })
                console.log('this is the data----', data)
                if (data && data.invoiceId) {
                    this.$router.push({
                        name: 'stripe-invoice-checkout',
                        params: {
                            invoiceId: data.invoiceId,
                        },
                    })
                }
            } catch (error) {
                console.log(error)
            }
            this.isLoading = false;
        },
        }
    }
</script>